export default __webpack_public_path__ + "static/media/comercio_13.298947b7.png";